<template>
  <div class="menu">
    <div class="menu-logo img-wrap">
      <img :src="logo" alt>
    </div>
    <el-menu
      class="el-menu-vertical-demo"
      background-color="#f0f3fa"
      text-color="#333333"
      active-text-color="#4c84ff"
      :default-active="$route.meta.activeMenu"
      @open="handleOpen"
      @close="handleClose"
    >
      <template v-for="item in menuLists">
        <el-submenu
          v-if="item._child && item._child.length"
          :key="item.id"
          :index="item.action"
        >
          <template slot="title">{{ item.title }}</template>
          <!-- 二级菜单 -->
          <template v-for="itemChild in item._child">
            <el-submenu
              v-if="itemChild._child && itemChild._child.length"
              :key="itemChild.id"
              :index="itemChild.action"
            >
              <template slot="title">{{ itemChild.title }}</template>
              <!-- 三级菜单 -->
              <el-menu-item
                v-for="itemChild_Child in itemChild._child"
                :key="itemChild_Child.id"
                :index="itemChild_Child.action"
              >
                <router-link slot="title" :to="itemChild_Child.url">{{
                  itemChild_Child.title
                }}</router-link>
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-else :key="itemChild.id" :index="itemChild.action">
              <router-link slot="title" :to="itemChild.url">{{
                itemChild.title
              }}</router-link>
            </el-menu-item>
          </template>
        </el-submenu>
        <el-menu-item v-else :key="item.id" :index="item.action">
          <router-link slot="title" :to="item.url">{{
            item.title
          }}</router-link>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  data() {
    return {
      logo: require('@/assets/img/logo.png'),
      menuLists: [
        {
          id: 0,
          title: '首页',
          url: '/admin/home',
          action: 'home'
        },
        {
          id: 4,
          title: '学员管理',
          url: '',
          action: 'users',
          _child: [
            {
              id: 41,
              title: '正式学员',
              url: '',
              action: 'studentList',
              _child: [
                {
                  id: 411,
                  title: '学员信息',
                  url: '/admin/users/studentList',
                  action: 'studentList'
                }
              ]
            },
            {
              id: 42,
              title: '新增Leads',
              url: '/admin/users/studentAdd',
              action: 'studentAdd'
            }
          ]
        },
        {
          id: 5,
          title: '套餐管理',
          url: '',
          action: 'combo',
          _child: [
            {
              id: 51,
              title: '套餐列表',
              url: '/admin/combo/comboList',
              action: 'comboList'
            },
            {
              id: 52,
              title: '套餐配置',
              url: '/admin/combo/setCombo',
              action: 'setCombo'
            },
            {
              id: 53,
              title: '套餐分组',
              url: '/admin/combo/comboGroup',
              action: 'comboGroup'
            }
          ]
        },
        {
          id: 31,
          title: '订单查询',
          url: '',
          action: 'orderSigning',
          _child: [
            {
              id: 311,
              title: '签约查询',
              url: '/admin/order/orderSigning',
              action: 'orderSigning'
            },
            {
              id: 312,
              title: '退款查询',
              url: '/admin/order/orderRefund',
              action: 'orderRefund'
            },
            {
              id: 313,
              title: '内转查询',
              url: '/admin/order/orderConverted',
              action: 'orderConverted'
            }
          ]
        },
        {
          id: 81,
          title: '订单审核',
          url: '',
          action: 'orderSigningAudit',
          _child: [
            {
              id: 811,
              title: '财务签约审核',
              url: '/admin/order/orderSigningAudit',
              action: 'orderSigningAudit'
            },
            {
              id: 812,
              title: '财务退款审核',
              url: '/admin/order/orderRefundAudit',
              action: 'orderRefundAudit'
            },
            {
              id: 813,
              title: '财务内转审核',
              url: '/admin/order/orderConvertedAudit',
              action: 'orderConvertedAudit'
            },
            {
              id: 814,
              title: '总部赠送审核',
              url: '/admin/order/orderGiveAudit',
              action: 'orderGiveAudit'
            }
          ]
        },
        {
          id: 7,
          title: '数据统计',
          url: '',
          action: 'statistics',
          _child: [
            {
              id: 71,
              title: '销售数据',
              url: '',
              action: 'salesData',
              _child: [
                {
                  id: 711,
                  title: '销售统计',
                  url: '/admin/statistics/salesStatistics',
                  action: 'salesStatistics'
                }
              ]
            },
            {
              id: 72,
              title: '招生数据',
              url: '',
              action: 'admissionsData',
              _child: [
                {
                  id: 721,
                  title: '招生统计',
                  url: '/admin/statistics/admissionsStatistics',
                  action: 'admissionsStatistics'
                },
                {
                  id: 722,
                  title: '渠道统计',
                  url: '/admin/statistics/channelStatistics',
                  action: 'channelStatistics'
                }
              ]
            },
            {
              id: 73,
              title: '运营数据',
              url: '/admin/statistics/operationalData',
              action: 'operationalData',
              _child: [
                {
                  id: 731,
                  title: '校区运营',
                  url: '/admin/statistics/campusStatistics',
                  action: 'campusStatistics'
                }
              ]
            },
            {
              id: 74,
              title: '人员绩效',
              url: '',
              action: 'performanceData',
              _child: [
                {
                  id: 741,
                  title: '班主任',
                  url: '/admin/statistics/teacherStatistics',
                  action: 'teacherStatistics'
                },
                {
                  id: 742,
                  title: '销售人员',
                  url: '/admin/statistics/salesmanStatistics',
                  action: 'salesmanStatistics'
                },
                {
                  id: 743,
                  title: '市场人员',
                  url: '/admin/statistics/marketStatistics',
                  action: 'marketStatistics'
                }
              ]
            }
          ]
        },
        {
          id: 6,
          title: '总部监管',
          url: '',
          action: 'headquarters',
          _child: [
            {
              id: 61,
              title: '目标计划',
              url: '/admin/headquarters/targetAndPlan',
              action: 'targetAndPlan'
            }
          ]
        },
        {
          id: 1,
          title: '托乐乐商学院',
          url: '',
          action: 'tuolele',
          _child: [
            {
              id: 11,
              title: '商学院',
              url: '/admin/tuolele/tuoleleIndex',
              action: 'tuoleleIndex'
            },
            {
              id: 12,
              title: '资料列表',
              url: '',
              action: 'dataManagement',
              _child: [
                {
                  id: 121,
                  title: '资料管理',
                  url: '/admin/tuolele/dataManagement',
                  action: 'dataManagement'
                },
                {
                  id: 122,
                  title: '分类管理',
                  url: '/admin/tuolele/sortManagement',
                  action: 'sortManagement'
                }
              ]
            }
          ]
        },
        {
          id: 2,
          title: '系统设置',
          url: '',
          action: 'system',
          _child: [
            {
              id: 22,
              title: '公司设置',
              url: '',
              action: 'companyInformation',
              _child: [
                {
                  id: 221,
                  title: '公司信息',
                  url: '/admin/system/companyInformation',
                  action: 'companyInformation'
                },
                {
                  id: 222,
                  title: '支付设置',
                  url: '/admin/system/paymentSetting',
                  action: 'paymentSetting'
                },
                {
                  id: 223,
                  title: '微信公众号设置',
                  url: '/admin/system/wechatSetting',
                  action: 'wechatSetting'
                },
                {
                  id: 225,
                  title: '人工月设置',
                  url: '/admin/system/calendarSetting',
                  action: 'calendarSetting'
                },
                {
                  id: 224,
                  title: '账号管理',
                  url: '/admin/system/accountManagement',
                  action: 'accountManagement'
                }
              ]
            },
            {
              id: 21,
              title: '店铺设置',
              url: '',
              action: 'storeSetting',
              _child: [
                {
                  id: 211,
                  title: '店铺管理',
                  url: '/admin/system/storeSetting',
                  action: 'storeSetting'
                },
                {
                  id: 212,
                  title: '扣费方式设置',
                  url: '/admin/system/chargeSetting',
                  action: 'chargeSetting'
                },
                {
                  id: 213,
                  title: '接校设置',
                  url: '/admin/system/pickUpSetting',
                  action: 'pickUpSetting'
                }
              ]
            },
            {
              id: 23,
              title: '通用设置',
              url: '',
              action: 'educationalSetting',
              _child: [
                {
                  id: 231,
                  title: '教务设置',
                  url: '/admin/system/educationalSetting',
                  action: 'educationalSetting'
                }
              ]
            },
            {
              id: 24,
              title: '增值服务',
              url: '/admin/system/serviceSetting',
              action: 'serviceSetting'
            },
            {
              id: 25,
              title: '账户管理',
              url: '/admin/system/accountFinancial',
              action: 'accountFinancial'
            },
            {
              id: 26,
              title: '公司管理',
              url: '/admin/system/companyManage',
              action: 'companyManage'
            }
          ]
        }
      ],
      userInfo: {}
    }
  },
  created() {
    this.userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
  },
  mounted() {
    this.getMenuData()
  },
  methods: {
    handleOpen() {},
    handleClose() {},
    async getMenuData() {
      var ret = await this.$http.getMenuData()
      if (ret.code == 200) {
        this.menuLists = []
        this.menuLists = ret.data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.menu {
  background-color: #f0f3fa;
  padding-top: 50px;
  height: 100%;
  a {
    display: block;
    height: 100%;
    color: $color_black;
  }
  .menu-logo {
    width: 80px;
    height: 80px;
    margin: 0 auto 50px;
  }
  .el-row {
    .el-col {
      width: 100%;
    }
  }
}
</style>
